var swalLoaded = false;

function delayedSwal() {
    var args = arguments;
    if (swalLoaded) {
        return swal.apply(this, args);
    }
    jQuery.getScript("https://cdnjs.cloudflare.com/ajax/libs/sweetalert/2.1.0/sweetalert.min.js", function () {
        swalLoaded = true;
        swal.apply(this, args);
    });
}

(function($) {
    function isotopeJsBlogArchive(){
        // external js: isotope.pkgd.js

        var $grid = $('.isotope');

        // bind filter button click
        var $filters = $('#filters').on( 'click', 'button', function() {
            var filterAttr = $( this ).attr('data-filter');
            // set filter in hash
            location.hash = 'filter=' + encodeURIComponent( filterAttr );
        });

        let $container;

        var isIsotopeInit = false;

        //isotope
        function getHashFilter() {
            var hash = location.hash;
            // get filter=filterName
            var matches = location.hash.match( /filter=([^&]+)/i );
            var hashFilter = matches && matches[1];
            return hashFilter && decodeURIComponent( hashFilter );
        }

        function onHashchange() {
            var hashFilter = getHashFilter();
            if ( !hashFilter && isIsotopeInit ) {
                return;
            }
            isIsotopeInit = true;
            // filter isotope
            $container = $grid.isotope({
                itemSelector: '.element-item',
                filter: hashFilter
            });
            // set selected class on button
            if ( hashFilter ) {
                $filters.find('.is-checked').removeClass('is-checked');
                $filters.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');

                console.log($('.blog-dropdown').find('[data-id="' + hashFilter + '"]').text());
                $('.js-blog-toggle').html($('.blog-dropdown').find('[data-id="' + hashFilter + '"]').text())
            }
        }

        $(window).on( 'hashchange', onHashchange );
        // trigger event handler to init Isotope
        onHashchange();

        //****************************
        // Isotope Load more button
        //****************************
        var initShow = 6; //number of items loaded on init & onclick load more button
        var counter = initShow; //counter for load more button
        var iso = $container.data('isotope'); // get Isotope instance

        //append load more button
        $container.after(`<div class="row mt-5"><div class="col-lg-12 text-center"><button class="btn btn-tertiary" id="load-more">`+ main.translations.load_more_blog_posts +`</button></div></div>`);


        loadMore(initShow); //execute function onload

        function loadMore(toShow) {
            $container.find(".hidden").removeClass("hidden");

            var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
                return item.element;
            });
            $(hiddenElems).addClass('hidden');
            $container.isotope('layout');

            //when no more to load, hide show more button
            if (hiddenElems.length === 0) {
                $("#load-more").hide();
            } else {
                $("#load-more").show();
            };

        }

        //when load more button clicked
        $("#load-more").click(function() {
            if ($('#filters').data('clicked')) {
                //when filter button clicked, set initial value for counter
                counter = initShow;
                $('#filters').data('clicked', false);
            } else {
                counter = counter;
            };

            counter = counter + initShow;

            loadMore(counter);
        });

        //when filter button clicked
        $("#filters").click(function() {
            $(this).data('clicked', true);

            loadMore(initShow);
        });
    }

    var slackInited = false;
    function initSlicks(){
        if (slackInited){
            return;
        }
        slackInited = true;
        $.getScript('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js', () => {
            $('#webinar-banner-slider').slick({
                infinite: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                speed: 1700,
                prevArrow: $("#webinar-prev-slide"),
                nextArrow: $("#webinar-next-slide"),
            });

            $('.products-slider').slick({
                infinite: true,
                arrows: true,
                appendArrows: $('.js-append-arrows'),
                slidesToShow: 4,
                slidesToScroll: 1,
                //autoplay: true,
                //autoplaySpeed: 5000
                prevArrow: $('.js-slick-prev-prod'),
                nextArrow: $('.js-slick-next-prod'),
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
            $('.blogs-slider').slick({
                infinite: true,
                arrows: true,
                appendArrows: $('.js-append-arrows'),
                slidesToShow: 3,
                slidesToScroll: 1,
                //autoplay: true,
                //autoplaySpeed: 5000
                prevArrow: $('.js-slick-prev-prod'),
                nextArrow: $('.js-slick-next-prod'),
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            $('.comments-slider').slick({
                infinite: true,
                arrows: true,
                dots: true,
                appendArrows: $('.js-comment-append-arrows'),
                slidesToShow: 3,
                slidesToScroll: 1,
                //autoplay: true,
                //autoplaySpeed: 5000
                prevArrow: $('.js-slick-prev-com'),
                nextArrow: $('.js-slick-next-com'),
                responsive: [

                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            $('.ebooks-slider').slick({
                infinite: true,
                arrows: true,
                appendArrows: $('.js-append-arrows'),
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                prevArrow: $('.js-slick-prev-ebook'),
                nextArrow: $('.js-slick-next-ebook')
            });
            if(typeof AOS!="undefined") {
                AOS.refresh();
            }
        });
    }

    $(() => {

        // no intersectionobserver
        if ('function' != typeof window.IntersectionObserver) {
            initSlicks();
        } else {
            var lazySlick = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (slider) {
                        if (slider.intersectionRatio <= 0) {
                            return;
                        }
                        lazySlick.unobserve(slider.target);
                        initSlicks();
                    });
                }
            );
            $('.products-slider,.blogs-slider,.comments-slider,#webinar-banner-slider,.ebooks-slider').each((i, item) => {
                lazySlick.observe(item);
            })
        }

        const highlightedItems = document.querySelectorAll(".hoverable");
        highlightedItems.forEach(function(elem) {
            elem.addEventListener("mouseover", function () {
                var bounding = this.getBoundingClientRect();
                if(bounding.top >= ((window.innerHeight || document.documentElement.clientHeight)/2)){
                    this.classList.add("hover-bottom");
                }else{
                    this.classList.add("hover-top");
                }

            });

            elem.addEventListener("mouseleave", function () {
                this.classList.remove("hover-bottom");
                this.classList.remove("hover-top");
            });
        });



        // flickr gallery fixes
        $(document).on('click', '.launch-gallery-swipebox', function (e) {
            console.log('open');
            $('.gallery-fixer').show();
        });
        $(document).on('click touchstart', '#swipebox-close', function (e) {
            console.log('close');
            $('.gallery-fixer').hide();
        });
        $(document).on('click touchstart', '.gallery-fixer', function (e) {
            console.log('close');
            $(this).hide();
        });

        //MENU TRANSFORM ON SCROLLING
        const nav = $('#menu');
        var lastScrollTop = 0;
        $(window).scroll(function() {
            if(0 <= $(window).scrollTop() && $(window).scrollTop() <= 120) {
                nav.css('transform', `translateY(-${$(window).scrollTop()}px)`);
            }

            if($(window).scrollTop() > 120) {
                nav.addClass('scrolled');
            } else {
                nav.removeClass('scrolled');
            }


            // DETECT SCROLL DIRECTION
            //
            var st = $(this).scrollTop();
            if (st <= lastScrollTop){
                nav.addClass('is-showed');
            } else {
                nav.removeClass('is-showed');
            }
            lastScrollTop = st;
        });

        $('.js-parallax').jarallax({
            speed: 0.2,
            disableParallax: /iPad|iPhone|iPod|Android/
        });

        $('.match-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-2').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-3').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-resources').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-resources2').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });


        //custom label animation

        // INPUT FOCUS EFFECT
        $(".form-control").focusin(function () {
            $(".form-group.is-focused").removeClass("is-focused");
            $(".form-control").each(function () {
                if ($(this).val() === "") {
                    $(this)
                        .parent()
                        .find(".js-label")
                        .removeClass("is-focused");
                }
            });

            $(this)
                .closest(".form-group")
                .addClass("is-focused");
            $(this)
                .parent()
                .find(".js-label")
                .addClass("is-focused");
        });

        $('.js-form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error',
            classHandler(el) {
                return el.$element.closest('.form-group');
            },
            errorsWrapper: '<div class="invalid-message error-text"></div>',
            errorTemplate: '<span></span>'
        });


        if ($('.js-archive-blogs').length) {
            // lazy load isotope
            $.getScript('https://cdnjs.cloudflare.com/ajax/libs/jquery.isotope/3.0.6/isotope.pkgd.min.js',function(){
                isotopeJsBlogArchive();
            })
        }

        //scroll anim
        $('.js-scroll').on('click', function(){
            $('html, body').animate({
                scrollTop: $('#whitepaper').offset().top
            }, 600);
        });

        $(document).on('click', '.js-shortcode-scroll', function (e) {
            if($(this).attr('href') === '#whitepaper') {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $('#whitepaper').offset().top
                }, 600);
            }
        });

        $('.js-scroll-mobile').on('click', function(){
            $('html, body').animate({
                scrollTop: $('#whitepaper').offset().top
            }, 600);
            $('.bt-menu-trigger').click();
        });

        $('#js-scroll-to-second').on('click', function(){
            $('html, body').animate({
                scrollTop: $('#second-section').offset().top - 50
            }, 900);
        });

        //404 animation
        if($('.animation-wrapper').length) {
            init();
        }

        var button = document.querySelector('.bt-menu-trigger');
        button.addEventListener('click', function (){
            button.classList.toggle('bt-menu-open');
        });


        //product anim

        $(document).on('click', '.tile__simple-img-mobile', function () {
            $(this).addClass('no-box');
            $('.tile__simple-img__back').removeClass('mobile-show');
            $(this).find('.tile__simple-img__back').addClass('mobile-show');
        });

        if ($(window).width() >= 768) {
            // animations
            if($('#scene').length) {
                var scene = document.getElementById('scene');
                var parallaxInstance = new Parallax(scene, {
                    relativeInput: false
                });
            }
            
            $.getScript('https://unpkg.com/aos@2.3.1/dist/aos.js',function(){
                $("body").removeClass("fp-responsive");
                AOS.init({
                    once: true,
                    disable: 'mobile'
                });
            })
        }

        $('.not-clickable').on('click', function (e) {
            e.preventDefault();

            if ($(window).width() < 992) {
                $(this).find('.dropdown-menu').toggleClass('active');
            }
        });

        $('.not-clickable .dropdown-menu').click(function(e){
            e.stopPropagation();

        });


        $('.name-validation').keydown(e => {
            // Allow: backspace, delete, tab, escape, enter and .
            if (
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                e.key === '+' ||
                // Allow: home, end, left, right, down, up
                (e.keyCode >= 35 && e.keyCode <= 40)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is char [a-zA-Z] or space, ', -, é,í,ó,ö,ő,ú,ü,ű
            if (
                (e.keyCode < 64 || e.keyCode > 90) &&
                (e.keyCode !== 32 &&
                    e.key !== "'" &&
                    e.keyCode !== 189 &&
                    e.keyCode !== 222 &&
                    e.keyCode !== 186 &&
                    e.keyCode !== 226 &&
                    e.keyCode !== 187 &&
                    e.keyCode !== 192 &&
                    e.keyCode !== 219 &&
                    e.keyCode !== 221 &&
                    e.keyCode !== 191 &&
                    e.keyCode !== 220)
            ) {
                e.preventDefault();
            }
        });

    // Resources page more buttons

      $('.js-load-more').on('click', function(e) {
        e.preventDefault();
        let moreButton = $(this);
        let parent = $(this).closest('section');
        
        if ($(parent).find('.resources__item-hidden').length != 0) {
          $(parent).find('.resources__item-hidden').each(function(index) {
            if (index === 6) {
              return;
            }
            $(this).removeClass('resources__item-hidden');
          });

          if ($(parent).find('.resources__item-hidden').length == 0) {
            moreButton.hide();
          }
        } else {
          moreButton.hide();
        }
      });
    });
})(jQuery);
